import React, { useCallback, useMemo } from "react";
import { useImmer } from "use-immer";


export enum LoadExtent {
    None = 0,
    Full = 1,
    Panel = 2
};

export interface IViewState {
    currentError: string,
    loadingExtent: LoadExtent
}

export interface IViewContext {
    viewState: IViewState;
    hasError: () => boolean;
    setError: (message: string) => void;
    clearError: () => void;
    isLoading: () => boolean;
    startLoading: (loadingExtent: LoadExtent) => void;
    stopLoading: () => void;
}

export const ViewContext = React.createContext(null);

const ViewStateProvider: React.FC = (props) => {
    const [viewState, setViewState] = useImmer<IViewState>({
        currentError: "",
        loadingExtent: LoadExtent.None
    });

    const hasError = useCallback(() => {
        return viewState?.currentError && viewState.currentError.length > 0;
    }, [viewState]);

    const setError = useCallback(message => {
        setViewState(draft => { draft.currentError = message; })
    }, []);

    const clearError = useCallback(() => {
        setViewState(draft => { draft.currentError = ''; })
    }, []);

    const isLoading = useCallback(() => {
        return (viewState?.loadingExtent)? true : false;
    }, [viewState])

    const startLoading = useCallback((loadingExtent: LoadExtent) => {
        setViewState(draft => { draft.loadingExtent = loadingExtent; })
    }, []);

    const stopLoading = useCallback(() => {
        setViewState(draft => { draft.loadingExtent = LoadExtent.None; })
    }, []);


    const stateData = useMemo<IViewContext>(() => ({ viewState, hasError, setError, clearError, isLoading, startLoading, stopLoading }),
        [viewState]);

    return (
        <ViewContext.Provider value={stateData}>
            {props.children}
        </ViewContext.Provider>
    );
};

export default ViewStateProvider;
